import { defineStore } from 'pinia'
import UserService from '../service/UserService';
const userService = new UserService();
export const useUsersStore = defineStore({
  id: 'user',
  state: () => ({
    users: [],
    user: {},
    loading: false,
    error: null,
    filters: [],
    sort_object: null,
    paginator_page: 1,
    paginator_size: 50,
    paginator_first: 1
  }),
  getters: {
    getUsers: (state) => {
      return state.users;
    },
    getUserDevices: (state) => {
      return state.user.devices;
    },
    getUser: (state) => {
      if (state.user && state.user.devices) {
        for (let device in state.user.devices) {
          state.user.devices[device].date_formatted = state.user.devices[device].registration_time.substring(0, 16);
        }
      }
      return state.user;
    },
    getUsersListFilters: (state) => {
      return state.filters;
    },
    getUsersSortObject: (state) => {
      return state.sort_object;
    },
    getUsersPaginatorPage: (state) => {
      return state.paginator_page;
    },
    getUsersPaginatorSize: (state) => {
      return state.paginator_size;
    },
    getUsersPaginatorFirst: (state) => {
      return state.paginator_first;
    }
  },
  actions: {
    setUsersListFilters(list_filters) {
      this.filters = list_filters;
    },
    setUsersSortObject(sort_object) {
      this.sort_object = sort_object;
    },
    setUsersPaginatorPage(paginator_page) {
      this.paginator_page = paginator_page;
    },
    setUsersPaginatorSize(paginator_size) {
      this.paginator_size = paginator_size;
    },
    setUsersPaginatorFirst(paginator_first) {
      this.paginator_first = paginator_first;
    },
    async setEmptyuser() {
      this.user = null;
    },
    filtersParser(filters) {
      let result = [];
      filters.forEach(filter => {
        if (filter && Object.keys(filter).length !== 0) {
          let operator = filter.key === "registration_time" ? "BETWEEN" : filter.key === "tags" ? "IN_LIST" : "CONTAINS";
          let attribute = filter.key === "tags" ? "tag_list" : filter.key
          let value = filter.key === "tags" ? filter.value.split(",").map((item) => item.trim()) : filter.value
          result.push({
            "attribute": attribute,
            "value": value,
            "operator": operator
          });
        }
      });
      return result;
    },
    async fetchUsers(limit = 10, offset = 0, filters = [], sortObject, count = true, count_attr = "registration_time") {
      this.users = []
      this.loading = true
      try {
        let filtersParsed = this.filtersParser(filters);
        this.users = await userService.fetchUsers(limit, offset, filtersParsed, sortObject, count, count_attr)
          .then((response) => response)
      } catch (error) {
        this.error = error
      } finally {
        this.loading = false
      }
    },
    async fetchUser(id) {
      this.loading = true
      try {
        this.user = await userService.fetchUser(id)
          .then((response) => response)
      } catch (error) {
        this.error = error
      } finally {
        this.loading = false
      }
    },
    async fetchDeleteUser(id, router) {

      try {
        await userService.fetchDeleteUser(id)
          .then((response) => response.items)
      } catch (error) {
        this.error = error
      }
    },
    getUsersListFiltersParsed(filters) {
      let result = this.filtersParser(filters);
      return result;
    },
    fetchPendingDealers() {
      return userService.fetchDealers();
    },
    approveDealer(email) {
      return userService.approveDealer(email);
    }
  }
});